module.exports = __webpack_public_path__ + "img/header-engagementRingsUsa.397bdca.webp";